export type RegisterFormMessages = {
  userNamePlaceholder: string;
  userNameLabel: string;
  emailPlaceholder: string;
  emailLabel: string;
  phonePlaceholder: string;
  phoneLabel: string;
  federalTaxIdLabel: string;
  companyNamePlaceholder: string;
  companyNameLabel: string;
  passwordPlaceholder: string;
  passwordLabel: string;
  confirmPasswordPlaceholder: string;
  confirmPasswordLabel: string;
  ddiLabel: string;
};

export const REGISTER_FORM_MESSAGES: RegisterFormMessages = {
  userNamePlaceholder: "Nome",
  userNameLabel: "Nome completo*",
  emailPlaceholder: "Email",
  emailLabel: "Email*",
  phonePlaceholder: "Telefone com DDD",
  phoneLabel: "Celular*",
  companyNamePlaceholder: "Empresa",
  companyNameLabel: "Empresa*",
  federalTaxIdLabel: "CNPJ*",
  passwordPlaceholder: "Senha",
  passwordLabel: "Senha*",
  confirmPasswordPlaceholder: "Confirme a senha",
  confirmPasswordLabel: "Confirme a senha*",
  ddiLabel: "País",
};
